module.exports = __webpack_public_path__ + "static/media/Well Rounded College Funding.b064fa80.pdf";